import angular from 'angular';

const reviewsServices = angular.module('applicationModule.reviewsServices', []);

reviewsServices.factory('Review', ['ReviewsAPI', function (ReviewsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return ReviewsAPI.getReviews(appId, params)
                .then(function (response) {
                    return response.data.review;
                });
        },
        getAbuse: function (reviewId) {
            return ReviewsAPI.getReviewAbuse(reviewId)
                .then(function (response) {
                    return response.data.abuse;
                });
        },
        setStatus: function (reviewId, status) {
            return ReviewsAPI.setReviewStatus(reviewId, status)
                .then(function (response) {
                    return response.data.status;
                });
        }
    };
}]);

reviewsServices.service('ReviewsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/reviews/';

    this.getReviews = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.getReviewAbuse = function (reviewId) {
        return $http.get(API_URL + reviewId);
    };
    this.setReviewStatus = function (reviewId, status) {
        return $http.post(API_URL + reviewId, {status: status});
    };
}]);

export default reviewsServices;
